const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000/api';

const getAuthToken = () => {
    return localStorage.getItem('accessToken');
};

const api = {
    async login(username, password) {
        const response = await fetch(`${API_URL}/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username, password }),
        });
        if (!response.ok) {
            throw new Error('Login failed');
        }
        return response.json();
    },

    async get(endpoint) {
        const token = getAuthToken();
        const response = await fetch(`${API_URL}/${endpoint}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            throw new Error(`Failed to fetch ${endpoint}`);
        }
        return response.json();
    },

    async getPublic(endpoint) {
        const response = await fetch(`${API_URL}/${endpoint}`);
        if (!response.ok) {
            throw new Error(`Failed to fetch ${endpoint}`);
        }
        return response.json();
    },

    async post(endpoint, data) {
        const token = getAuthToken();
        const headers = {
            'Authorization': `Bearer ${token}`,
        };

        let body = data;
        if (!(data instanceof FormData)) {
            headers['Content-Type'] = 'application/json';
            body = typeof data === 'string' ? data : JSON.stringify(data);
        }

        const response = await fetch(`${API_URL}/${endpoint}`, {
            method: 'POST',
            headers,
            body,
        });
        if (!response.ok) {
            const errData = await response.json().catch(() => ({}));
            throw new Error(errData.error || `Failed to create ${endpoint}`);
        }
        return response.json();
    },

    async put(endpoint, data) {
        const token = getAuthToken();
        const headers = {
            'Authorization': `Bearer ${token}`,
        };

        let body = data;
        if (!(data instanceof FormData)) {
            headers['Content-Type'] = 'application/json';
            body = typeof data === 'string' ? data : JSON.stringify(data);
        }

        const response = await fetch(`${API_URL}/${endpoint}`, {
            method: 'PUT',
            headers,
            body,
        });
        if (!response.ok) {
            const errData = await response.json().catch(() => ({}));
            throw new Error(errData.error || `Failed to update ${endpoint}`);
        }
        return response.json();
    },

    async delete(endpoint) {
        const token = getAuthToken();
        const response = await fetch(`${API_URL}/${endpoint}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            throw new Error(`Failed to delete ${endpoint}`);
        }
        return response.json();
    },

    async download(endpoint) {
        const token = getAuthToken();
        const response = await fetch(`${API_URL}/${endpoint}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            throw new Error(`Failed to download ${endpoint}`);
        }
        return response;
    },
};

export default api;